import { wrapServer } from '../config/axios';
import api from '../config/api';

export enum ACTION_TYPE {
  SYSROLE = 'SYSROLE',
  ROLE_STATUS = 'ROLE_STATUS',
  GET_ROLE = 'GET_ROLE',
  CHANGE_PERM = 'CHANGE_PERM',
  GET_USER_INFO = 'GET_USER_INFO',
  CHANGE_ROLE_TYPE = 'CHANGE_ROLE_TYPE',
  USER_INFO_STATUS = 'USER_INFO_STATUS',
  CREATE_ROLE = 'CREATE_ROLE',
  CREATE_USER = 'CREATE_USER',
  USER_GET_ROLE = 'USER_GET_ROLE',
  GET_ROLE_LIST = 'GET_ROLE_LIST',
}

export const sysRole = (params) => {
  return {
    type: ACTION_TYPE.SYSROLE,
    promise: wrapServer({
      method: 'get',
      url: api.sysRole,
      params
    }),
  };
};

export const roleStatus = (params: any) => {
  return {
    type: ACTION_TYPE.ROLE_STATUS,
    promise: wrapServer({
      method: 'patch',
      url: `${api.roleStatus}/${params.id}`,
    }),
  };
};

export const getRole = (params: any) => {
  return {
    type: ACTION_TYPE.GET_ROLE,
    promise: wrapServer({
      method: 'get',
      url: `${api.getRole}/${params.id}`,
    }),
  };
};

export const changePerm = ({params, data}: any) => {
  return {
    type: ACTION_TYPE.CHANGE_PERM,
    promise: wrapServer({
      method: 'put',
      url: `${api.changePerm}/${params.id}`,
      data
    }),
  };
};

export const getUserInfo = (params: any) => {
  return {
    type: ACTION_TYPE.GET_USER_INFO,
    promise: wrapServer({
      method: 'get',
      url: `${api.getUserInfo}`,
      params,
    }),
  };
};

export const changeRoleType = ({params, data}: any) => {
  return {
    type: ACTION_TYPE.CHANGE_ROLE_TYPE,
    promise: wrapServer({
      method: 'put',
      url: `${api.changeRoleType}/${params.id}`,
      data
    }),
  };
};

export const useInfoStatus = (params: any) => {
  return {
    type: ACTION_TYPE.USER_INFO_STATUS,
    promise: wrapServer({
      method: 'patch',
      url: `${api.useInfoStatus}/${params.id}`,
    }),
  };
};

export const createRole = (data: any) => {
  return {
    type: ACTION_TYPE.CREATE_ROLE,
    promise: wrapServer({
      method: 'post',
      url: api.createRole,
      data,
    }),
  };
};

export const createUser = (data: any) => {
  return {
    type: ACTION_TYPE.CREATE_USER,
    promise: wrapServer({
      method: 'post',
      url: api.createUser,
      data,
    }),
  };
};

export const userGetRole = (params: any) => {
  return {
    type: ACTION_TYPE.USER_GET_ROLE,
    promise: wrapServer({
      method: 'get',
      url: `${api.userGetRole}/${params.id}`,
    }),
  };
};

export const getRoleList = () => {
  return {
    type: ACTION_TYPE.GET_ROLE_LIST,
    promise: wrapServer({
      method: 'get',
      url: api.sysRole
    }),
  };
};

export default {
  sysRole,
  getUserInfo,
  ACTION_TYPE
};